import { ExportToCsv } from "export-to-csv";
import moment from "moment";
import { FunctionComponent, useState, useEffect } from "react";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import { GetInventoryListApi } from "../../../../service/repos/inventory_repo";
import { getComplaints } from "../../../../service/repos/support/complaint_repo";
import { UTCToLocalDate } from "../../../../utils/date_util";
import LoadingWidget from "../../../../ui/pages/content_panel/ui/new_components/common/loading_spinner";
import StadiumButton from "../../../../ui/new_components/common/stadium_button";
import { ExportPOListDataRepo, getPurchaseOrderSummarizedListDataRepo } from "../service/po_service";
import { PurchaseOrderModelV2 } from "../../model/purchase_order_model";
import { currencyFormat } from "../../../../utils/currency_format";
import { urls } from "../../../../utils/urls";
import { isProduction } from "../../../..";
import { format } from "date-fns";
import { Attachment } from "@material-ui/icons";

interface ExportPOProps {
  filter: {
    page: number;
    count: number;
    all: boolean | null;
    search?: string;
    fromDate?: Date;
    toDate?: Date;
    party_id?: string;
    party_name?: string;
    approval_status?: string[];
  };
}

const ExportPO: FunctionComponent<ExportPOProps> = (props) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PurchaseOrderModelV2[]>([]);
  const [fromDate, setFromdate] = useState<Date>();
  const [toDate, setTodate] = useState<Date>();

  const getPODetailedListData = async () => {
    const filter = props.filter;
    setLoading(true);
    try {
      // filter.fromDate = fromDate;
      // filter.toDate = toDate;
      const searchProp = { ...filter };
      searchProp.all = true;
      const res = await ExportPOListDataRepo(searchProp);
      if (res.success) {
        // console.log("reslt:", res.data.downloadUrl);
        // window.open(res.data.downloadUrl);

        showToast({
          type: ToastType.info,
          text: res.message,
        });
      } else {
        console.log(res.error);
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };

  const getPOSummarisedListData = async () => {
    const filter = props.filter;
    setLoading(true);
    try {
      // filter.fromDate = fromDate;
      // filter.toDate = toDate;
      const searchProp = { ...filter };
      searchProp.all = true;
      const res = await getPurchaseOrderSummarizedListDataRepo(searchProp);
      if (res.success) {
        console.log(res.data);
        showToast({
          type: ToastType.info,
          text: res.message,
        });
      } else {
        console.log(res.error);
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };
  useEffect(() => {
    const date = new Date();

    if (props.filter?.fromDate && props.filter.toDate) {
      setFromdate(props.filter.fromDate);
      setTodate(props.filter.toDate);
    } else {
      setFromdate(new Date(date.setHours(0, 0, 0, 0)));
      setTodate(new Date(date.setHours(23, 59, 59, 999)));
    }
  }, []);

  // return (
  //   <div className="p-5">
  //     <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
  //       <div className="">
  //         <label htmlFor="from-date">From</label>
  //         <input
  //           id="from-date"
  //           className="border rounded p-2 w-full"
  //           type="date"
  //           name="fromDate"
  //           placeholder="From"
  //           required
  //           value={moment(fromDate).format("YYYY-MM-DD")}
  //           onChange={(e) => {
  //             let date = UTCToLocalDate(e.target.value)!;
  //             date = new Date(date.setHours(0, 0, 0, 0));
  //             if (toDate && moment(date).isAfter(moment(toDate))) {
  //               showToast({
  //                 type: ToastType.warning,
  //                 text: "From Date should not be greater than To Date ",
  //               });
  //               return;
  //             }
  //             setFromdate(date);
  //           }}
  //         />
  //       </div>
  //       <div className="">
  //         <label htmlFor="to-date">To</label>
  //         <input
  //           id="to-date"
  //           className="border rounded p-2 w-full"
  //           type="date"
  //           name="toDate"
  //           placeholder="To"
  //           required
  //           value={moment(toDate).format("YYYY-MM-DD")}
  //           min={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
  //           onChange={(e) => {
  //             let date = UTCToLocalDate(e.target.value)!;
  //             date = new Date(date.setHours(23, 59, 59, 999));
  //             if (fromDate && moment(fromDate).isAfter(moment(date))) {
  //               showToast({
  //                 type: ToastType.warning,
  //                 text: "To Date should  be greater than From Date ",
  //               });
  //               return;
  //             }
  //             setTodate(date);
  //           }}
  //         />
  //       </div>
  //     </div>
  //     <div className="flex justify-end my-2">
  //       <StadiumButton type="submit" onTap={getPOListData}>
  //         Export
  //       </StadiumButton>
  //     </div>
  //     <LoadingWidget loading={loading} />
  //   </div>
  // );
  return (
    <div className="p-5">
      <div className="flex gap-4 justify-center my-4">
        <StadiumButton type="button" onTap={getPODetailedListData}>
          Detailed Export
        </StadiumButton>
        <StadiumButton type="button" onTap={getPOSummarisedListData}>
          Summarised Export
        </StadiumButton>
      </div>

      <LoadingWidget loading={loading} />
    </div>
  );
};

export default ExportPO;
